/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Tabs, Button } from 'antd';
import LoadingComponent from '../../components/loading/LoadingComponent';
import OverviewComponent from './overview';
import SwitchToggler from './SwitchToggler';
import SmWalletIcon from '../../assets/icons/sm-wallet-icon';
import SmTerminalIcon from '../../assets/icons/sm-terminal-icon';
import SmCardIcon from '../../assets/icons/sm-card-icon';
import Layout from '../../components/Layout';
import { customBaseUrl, httpGet } from '../../store/http';
import { hideLoader, showLoader } from '../../utils/loader';
import DashboardOverView from './dashOverview';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NotificationManager } from 'react-notifications';
// import RecentUsersComponent from './RecentUsersComponent';
// import TransactionSummaryComponent from './TransactionSummaryComponent';
// import LogSummaryComponent from './LogSummaryComponent';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabContent: {
    padding: '5px 0 25px 0',
  },
  textHeader: {
    fontStyle: 'normal',
    fontSeight: 500,
    fontSize: 15,
    lineHeight: '18px',
    color: 'rgba(0, 0, 0, 0.4)',
    textAlign: 'center',
  },
}));

const DashboardAnalysis = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);
  const [state, setState] = React.useState(false);
  const [to, setTo] = React.useState(moment().format('YYYY-MM-DD'));
  const [from, setFrom] = React.useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
  const [analysis, setAnalysis] = useState(null)
  const [tierData, setTierData] = useState(null)

  const [title, setTitle] = React.useState(
    'ACCOUNT OVERVIEW',
  );
  const [loading] = React.useState(false);
  const { TabPane } = Tabs;
  const handleChange = (val) => {
    setValue(val);
    setState(false);
    if (val == '1') setTitle('WALLET PRODUCT PERFORMANCE METRICS');
    if (val == '2') setTitle('WEB POS PRODUCT PERFORMANCE METRICS');
    if (val == '3') setTitle('TERMINAL POS PRODUCT PERFORMANCE METRICS');
  };

  const handleToggler = (event) => {
    if (state) {
      setState(false);
    } else {
      setState(true);
    }
  };

  const getStat = async (from, to) => {
    showLoader()
    try {
      const startIso = `${from}T00:00:00`;
      const endIso = `${to}T23:59:59`;
      const systemUrl = `${customBaseUrl.tranv2}/api/v1/admin/statistics/system?startDate=${startIso}&endDate=${endIso}`;
      const tierUrl = `${customBaseUrl.tranv2}/api/v1/admin/statistics/tier-accounts/cumulative?startDate=${startIso}&endDate=${endIso}`;

      const [systemRes, tierRes] = await Promise.all([
        httpGet(systemUrl),
        httpGet(tierUrl)
      ]);

      if (systemRes.data) {
        setAnalysis(systemRes.data);
      }
      if (tierRes.data) {
        setTierData(tierRes.data);
      }
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
    } finally {
      hideLoader();
    }
  }

  const exportAnalyticsToExcel = () => {
    if (!analysis && !tierData) {
      NotificationManager.warning('No analytics data available to export.');
      return;
    }

    const wb = XLSX.utils.book_new();
    const data = [];

    // System Overview
    if (analysis) {
      data.push(['SYSTEM TRANSACTION OVERVIEW']);
      data.push(['Metric', 'Value']);
      data.push(['Total Transactions', analysis.totalTransactions]);
      data.push(['Successful Transactions', analysis.successfulTransactions]);
      data.push(['Pending Transactions', analysis.pendingTransactions]);
      data.push(['Failed Transactions', analysis.failedTransactions]);
      data.push([]);
    }

    // Tier Analytics
    if (tierData) {
      const categories = [
        { key: 'personal', name: 'PERSONAL ACCOUNTS' },
        { key: 'nonCac', name: 'NON-CAC BUSINESS ACCOUNTS' },
        { key: 'cac', name: 'CAC BUSINESS ACCOUNTS' },
      ];

      categories.forEach(cat => {
        const stats = tierData[cat.key];
        if (stats) {
          data.push([cat.name]);
          data.push(['Tier', 'Count', 'Amount (₦)']);
          data.push(['Tier 1', stats.tier1, stats.tier1Amount]);
          data.push(['Tier 2', stats.tier2, stats.tier2Amount]);
          data.push(['Tier 3', stats.tier3, stats.tier3Amount]);
          data.push(['Tier 4', stats.tier4, stats.tier4Amount]);
          data.push(['Total', stats.total, stats.totalAmount]);
          data.push([]);
        }
      });

      data.push(['OVERALL CUMULATIVE SUMMARY']);
      data.push(['Metric', 'Value']);
      data.push(['Total Accounts', tierData.total]);
      data.push(['Total Amount (₦)', tierData.totalAmount]);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Analytics');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    let filename = `Analytics_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
    if (from && to) {
      filename = `Analytics_${from}_to_${to}.xlsx`;
    }

    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
  };

  useEffect(() => {
    if (to && from) {
      getStat(from, to);
    }
  }, [from, to])

  return (
    <Layout>
      <div className={classes.root}>
        <h3 className={classes.textHeader}>{title}</h3>
        <div className="p-3 input-container d-flex">
          <span className="text-muted fs-12 mx-1">From</span>
          <input className="input fs-12" type="date" value={from} onChange={(e) => setFrom(e?.target.value)} />
          <span className="text-muted fs-12 me-1">To</span>
          <input className="input fs-12" type="date" value={to} onChange={(e) => setTo(e?.target.value)} />
        </div>
        <Tabs
          defaultActiveKey="1"
          size="large"
          tabBarStyle={{ paddingLeft: 20 }}
          onChange={handleChange}
          animated
          tabBarExtraContent={
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Button
                type="primary"
                onClick={exportAnalyticsToExcel}
                disabled={!analysis && !tierData}
              >
                Download Analytics
              </Button>
              <SwitchToggler handleToggler={handleToggler} state={state} />
            </div>
          }
        >
          <TabPane
            tab={
              <></>
            }
            key="1"
          >
            <DashboardOverView state={state} analysis={analysis} tierData={tierData} />
          </TabPane>

        </Tabs>
      </div>
    </Layout>
  );
};

export default DashboardAnalysis;
